import { render, staticRenderFns } from "./ChatFixed.vue?vue&type=template&id=7a4ff0c0&scoped=true&"
import script from "./ChatFixed.vue?vue&type=script&lang=js&"
export * from "./ChatFixed.vue?vue&type=script&lang=js&"
import style0 from "./ChatFixed.vue?vue&type=style&index=0&id=7a4ff0c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4ff0c0",
  null
  
)

export default component.exports